<template>
  <div id="webview-page">
    <!-- 头部可以复用，但隐藏导航菜单 -->
    <HeaderTop :headIndex="5"></HeaderTop>
    
    <!-- iframe 容器 -->
    <div class="webview-container">
      <iframe 
        :src="iframeUrl" 
        class="webview-iframe"
        frameborder="0"
        allowfullscreen
        @load="onIframeLoad"
        @error="onIframeError"
      ></iframe>
    </div>
    
    <!-- 尾部 -->
    <Footer></Footer>
  </div>
</template>

<script>
import HeaderTop from '@/components/assembly/HeaderTop.vue';
import Footer from '@/components/assembly/Footer.vue';

export default {
  name: 'WebView',
  components: {
    HeaderTop,
    Footer
  },
  data() {
    return {
      iframeUrl: '',
      loading: true,
      error: false
    }
  },
  created() {
    // 从路由参数获取要加载的 URL
    this.iframeUrl = this.$route.query.url || '/xzwh/product.html';
  },
  methods: {
    onIframeLoad() {
      this.loading = false;
      console.log('iframe 加载成功');
    },
    onIframeError() {
      this.error = true;
      this.loading = false;
      console.error('iframe 加载失败');
    }
  }
}
</script>

<style scoped>
#webview-page {
  min-width: 1280px;
  background: #F5F3FB;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.webview-container {
  flex: 1;
  background: #fff;
  margin: 13px auto;
  max-width: 1280px;
  width: 100%;
  border-radius: 10px;
  /* overflow: hidden; */
  position: relative;
}

.webview-iframe {
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 200px);
  border: none;
  display: block;
}

/* 加载提示 */
.loading-tip {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #999;
}

/* 错误提示 */
.error-tip {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #db414e;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/pc_viwe/product.vue